import axios from '../../app/axiosConfig';

export const loginReq = (data) => {
  return axios.post('/login', data);
};

export const createPasswordReq = (data) => {
  return axios.post('/users/createPassword', data);
};
